import posthog from 'posthog-js';
import {
  PersonalisedQuoteVariant,
  PosthogFeatureFlags,
  isPersonalisedQuoteVariant,
} from '../../enums/featureFlags';
import { log } from '../log';
/**
 * Reads the tenant's personalised quote flag and narrows the answer to a known variant.
 * Asking PostHog is also what records the exposure ($feature_flag_called), so the flag is read
 * once per quote rather than on every render of the quote page.
 *
 * @returns The variant, or undefined when the brand has no flag, the user is outside the rollout,
 * or PostHog returns a variant we don't know (logged, then treated as control).
 */
export const getPersonalisedQuoteVariant = (
  flag: PosthogFeatureFlags | undefined,
): PersonalisedQuoteVariant | undefined => {
  if (!flag) return undefined;

  const flagResponse = posthog.getFeatureFlag(flag);

  if (isPersonalisedQuoteVariant(flagResponse)) return flagResponse;

  if (flagResponse) {
    log.warn({
      message:
        'Unrecognised personalised quote variant from PostHog, falling back to the default quote page',
      data: { flag, response: flagResponse },
    });
  }

  return undefined;
};
